import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const TEMPLATE_CENTER_CONTEXT_SYMBOL = Symbol();
const useTemplateCenter = ()=>useImmutableContext(TEMPLATE_CENTER_CONTEXT_SYMBOL);
const useTemplateCenterProvider = (...args)=>useImmutableContextProvider(TEMPLATE_CENTER_CONTEXT_SYMBOL, ...args);
export { useTemplateCenter, useTemplateCenterProvider };
